module.exports = __webpack_public_path__ + "static/media/pt_mb.9f1de8a7.svg";